export const filter = (() => {
    const videoplaybtns = document.querySelectorAll(".video-play");
    const videoplayer = document.getElementById("videoplayer");
    Array.from(videoplaybtns).forEach((btn) => addEL(btn));

    document.querySelectorAll(".js-cookie-renew").forEach((btn) => {
        btn.addEventListener("click", () => window.Cookiebot && window.Cookiebot.renew());
    });

    document.querySelectorAll(".js-preview-video").forEach((preview) => {
        preview.addEventListener("click", (e) => {
            if (!hasMarketingConsent()) {
                e.stopImmediatePropagation();
                window.Cookiebot && window.Cookiebot.renew();
            }
        });
    });

    function hasMarketingConsent() {
        return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing);
    }

    function addEL(btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            Array.from(videoplaybtns).forEach((btn) => { btn.classList.remove("video-play--active"); btn.setAttribute("aria-label", "Välj klipp") });
            btn.classList.add("video-play--active");
            btn.setAttribute("aria-label", "Aktivt klipp")
            videoplayer.setAttribute(hasMarketingConsent() ? "src" : "data-cookieblock-src", btn.getAttribute("data-link"));

            const previewBtn = videoplayer.parentElement.querySelector('.js-preview-video');
            if (previewBtn) {
                previewBtn.click();
            }
        });
    }

})();